import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Check } from "lucide-react";
import clsx from "clsx";
import { Fade } from "react-awesome-reveal";

import SectionTitle from "./SectionTitle";

import accountsLaptop from "../../img/home/accounts-laptop.webp";
import accountsPhone from "../../img/home/accounts-phone.webp";
import accountsCard from "../../img/home/accounts-card.webp";

const TABS = [
  {
    labelKey: "accountsPage.levels.tier1.name",
    features: ["accounts.tier1.feature1", "accounts.tier1.feature2"],
  },
  {
    labelKey: "accountsPage.levels.tier2.name",
    features: ["accounts.tier2.feature1", "accounts.tier2.feature2"],
  },
  {
    labelKey: "accountsPage.levels.tier3.name",
    features: ["accounts.tier3.feature1", "accounts.tier3.feature2"],
  },
  {
    labelKey: "accountsPage.levels.tier4.name",
    features: ["accounts.tier4.feature1", "accounts.tier4.feature2"],
  },
  {
    labelKey: "accountsPage.levels.tier5.name",
    features: ["accounts.tier5.feature1", "accounts.tier5.feature2"],
  },
];

function Accounts() {
  const { t } = useTranslation();
  const [active, setActive] = useState(0);

  return (
    <section className="mt">
      <div className="glcontainer">
        <div className="flex flex-col lg:flex-row gap-[25px] lg:gap-[69px] items-start">
          {/* Слева: коллаж (только desktop) */}
          <Fade triggerOnce direction="left" duration={700} className="hidden lg:block w-[51.3%] shrink-0">
          <div className="relative w-full aspect-[626/492]">
            {/* Верхняя левая фотография */}
            <div className="absolute left-0 top-0 w-[45.7%] h-[57.3%] rounded-[20px] overflow-hidden">
              <img src={accountsLaptop} alt="" aria-hidden className="w-full h-full object-cover" />
            </div>

            {/* Центральная высокая фотография */}
            <div className="absolute left-[49.7%] top-[8.9%] w-[50.3%] h-[78.9%] rounded-[20px] overflow-hidden">
              <img
                src={accountsPhone}
                alt=""
                aria-hidden
                className="w-full h-full object-cover object-[89%_50%]"
              />
            </div>

            {/* Нижний блок: синяя плашка + ноутбук */}
            <div className="absolute left-0 bottom-0 w-[45.7%] h-[44.5%]">
              <div className="absolute left-0 bottom-0 w-full h-[85%] bg-[#30425a] rounded-[20px]" />
              <img
                src={accountsCard}
                alt=""
                aria-hidden
                className="absolute left-[8.4%] bottom-0 w-[91.6%] h-full object-cover object-bottom rounded-br-[20px]"
              />
            </div>
          </div>
          </Fade>

          {/* Справа: контент */}
          <div className="flex flex-col gap-[25px] lg:gap-[28px] flex-1 lg:pt-[44px] w-full">
            <SectionTitle
              title1={t("accounts.title1")}
              title2={t("accounts.title2")}
              text={t("accounts.subtitle")}
              align="left"
            />

            {/* Типы аккаунтов */}
            <div className="flex flex-wrap gap-[16px] justify-center lg:justify-start">
              {TABS.map((tab, i) => (
                <button
                  key={tab.labelKey}
                  type="button"
                  onClick={() => setActive(i)}
                  className={clsx(
                    "flex items-center px-[14px] lg:px-[18px] py-[6px] lg:py-[8px] rounded-full border border-[#1c385f] font-['Inter'] font-normal text-[14px] lg:text-[16px] uppercase text-[#1c385f] transition-colors duration-200",
                    active === i ? "bg-[#bfccd7]" : "hover:bg-[#e4ebf1]"
                  )}
                >
                  {t(tab.labelKey)}
                </button>
              ))}
            </div>

            {/* Список преимуществ активного аккаунта */}
            <div className="flex flex-col gap-[18px]">
              {TABS[active].features.map((featKey) => (
                <div key={featKey} className="flex items-center gap-[15px]">
                  <div className="check-icon-blue">
                    <Check className="w-[14px] h-[14px] text-[#4da6ff]" strokeWidth={2.5} />
                  </div>
                  <span className="font-16-14">{t(featKey)}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Accounts;
